import getConfig from 'next/config';

const {publicRuntimeConfig: config, serverRuntimeConfig} = getConfig();

const isEnabled = (feature) => config.feature[feature] === true;

const enable = (feature) => (config.feature[feature] = true);

const disable = (feature) => (config.feature[feature] = false);

const updateFeatures = (features) => {
    if (process.browser) {
        if (!features) {
            return;
        }
        for (let feature in features) {
            config.feature[feature] = features[feature];
        }
    }
};

const getFeatureConfig = ({query}) => {
    let featureConfig = {...config.feature};

    if (!process.browser) {
        if (query.disableExternalDependencies && query.disableExternalDependencies > Math.floor(Date.now() / 1000)) {
            if (query.sign && query.sign === serverRuntimeConfig.adminSignature) {
                featureConfig.externalDependencies = false;
            }
        }
    }

    return featureConfig;
};

export {isEnabled, enable, disable, updateFeatures, getFeatureConfig};
